import React from 'react'
import '../Style/Footer.css'
import ElectricLogo from '../Logos/ElectroTechLogo.png'
import InstagramIcon from '../Logos/brand-instagram.svg'
import TelegramIcon from '../Logos/brand-telegram.svg'
import PhoneIcon from '../Logos/phone.svg'
import AddressIcon from '../Logos/map.svg'
import ZarinPalIcon from '../Logos/enamad_icon__text_color_blue_1024-300x300.png'
import EnamadIcon from '../Logos/zarinpal-logo.png'

function Footer() {
    return (
        <>
            <footer>
                <div className='footer-elements'>
                    <img src={ElectricLogo} className='electric-logo' />
                    <div className='texts-container'>
                        <div className='permissions-container'>
                            <div className='title'>نماد های اعتماد</div>
                            <div className='permissions-logo-container'>
                                <img src={ZarinPalIcon}/>
                                <img src={EnamadIcon}/>
                            </div>
                        </div>
                        <div className='contact-us-container'>
                            <div className='contact-us-texts'>
                                <div className='title'>ارتباط با ما</div>
                                <div className='call-number'>
                                    <div>شماره تماس: 02100000</div>
                                    <img src={PhoneIcon} />
                                </div>
                                <div className='address'>
                                    <div>ادرس: فلان جا</div>
                                    <img src={AddressIcon} />
                                </div>
                            </div>
                            <div className='social-medias-container'>
                                <div className='title'>فضای مجازی ما</div>
                                <div className='links'>
                                    <a href=''><img src={InstagramIcon} /></a>
                                    <a href=''><img src={TelegramIcon} /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='copy-right-text'>&copy; 2023 ElectroTech.ir | ElectroTech</div>
                </div>
            </footer>
        </>
    )
}

export default Footer